import { useSirUpdateMutation } from '../../../../graphql/react-operations';
import { BvContactForm } from '../../../../components/BvContactForm';
import { ShareIssueDocument } from '../../ShareIssue.graphql';
import { useStepper } from '../../../../components/steppers/common/StepperContext';
import { GqlCompany, GqlShareIssueRegistration } from '../../../../graphql/base-types.graphql';
import { DisplayIdentity } from '@startuptools/business-ui/identity/Identity';

export const SiStepRegForm = ({
  company,
  shareIssueRegistration,
}: {
  company: Pick<GqlCompany, 'id'>;
  shareIssueRegistration: Pick<GqlShareIssueRegistration, 'id' | 'regFormPaymentThroughBolago'> & {
    contact?: DisplayIdentity | null;
    signatory?: DisplayIdentity | null;
  };
}) => {
  const { stepNext } = useStepper();

  const [updateSir, { loading, error }] = useSirUpdateMutation({
    refetchQueries: [ShareIssueDocument],
    awaitRefetchQueries: true,
  });

  return (
    <BvContactForm
      loading={loading}
      error={error}
      onSave={async data => {
        await updateSir({
          variables: {
            companyId: company.id,
            input: { ...data, id: shareIssueRegistration.id },
          },
        });
        await stepNext();
      }}
      defaultValues={shareIssueRegistration}
    />
  );
};
